import FeedbackHistory from './FeedbackHistory';
import styles from './index.module.scss';
import AlertsBanner from './AlertsBanner';
import OverviewSummaryBox from './OverviewSummaryBox';
import CallHistoryBox from './CallHistoryBox';
import BankDetails from './BankDetails';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { createKey } from 'src/utils/CaseDetail.utils';
import { useParams } from 'react-router-dom';
import cx from 'classnames';
import { useEffect, useMemo } from 'react';
import { addClickstreamEvent } from '../../../../service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '../../../../service/clickStream.constant';
import PendingActions from './PendingActions';
import RecommendedCaseBox from './RecommendedCaseBox';
import { ActionType } from './utils';

const Overview = () => {
  const { loanId = '', customerId = '', caseReferenceId = '' } = useParams();

  const pageData = useSelector(
    (state: RootState) => state.caseDetail.pageData?.[createKey(loanId, customerId)]
  );
  useEffect(() => {
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_Overview_PageLand);
  }, []);

  const { customerInfo: customerDetails } = pageData || {};

  const isPaused = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.pause?.data?.isPaused
  );

  const currentRecommendedCase = useSelector(
    (state: RootState) => state?.caseRecommendation?.currentRecommendedCase
  );

  const toShowRecommendedAttributes = useMemo(() => {
    return Boolean(
      currentRecommendedCase?.caseReferenceId && currentRecommendedCase?.customerReferenceId
    );
  }, [currentRecommendedCase?.caseReferenceId, currentRecommendedCase?.customerReferenceId]);

  return (
    <div
      className={cx(styles.overviewWrapper, 'tabContentScroll', {
        tabContentScrollWithPausedCase: isPaused
      })}
    >
      <div className="flex flex-row justify-between items-center">
        {toShowRecommendedAttributes && <RecommendedCaseBox />}
        <PendingActions
          caseReferenceId={caseReferenceId}
          loanaccountnumber={loanId}
          customerreferenceid={customerId}
        />
      </div>
      <AlertsBanner />
      <OverviewSummaryBox />
      <CallHistoryBox />
      <FeedbackHistory />
      <BankDetails
        accountNumber={customerDetails?.data?.bankAccounts?.[0]?.accountNumber || ''}
        bankName={customerDetails?.data?.bankAccounts?.[0]?.bankName || ''}
        ifscCode={customerDetails?.data?.bankAccounts?.[0]?.ifsc || ''}
      />
    </div>
  );
};

export default Overview;
